import { Component, OnInit } from '@angular/core';
import { AslibGridComponent } from '@aslib/components';
import { AslibModalComponent,IAslibModalOptions } from '@aslib/modal';
import { BaseComponentService } from '../../services/base-component.service';
import { CargaDados } from '../../models/pagamento/carga-dados';

@Component({
  selector: 'gpa-carga-dados',
  templateUrl: './carga-dados.component.html',
  providers: [BaseComponentService]
})
export class CargaDadosComponent extends BaseComponentService implements OnInit {
  protected aslibModal: AslibModalComponent;
  nomeArquivo: string;
  file: File;
  desabilitar: boolean;
  desabilitarRemover: boolean;
  desabilitarSalvar: boolean;


  lista: any[];
  retorno: any;
  msg: any;
  obj:any;
  itemSelecionado: CargaDados;
  statusNaoValidos = 1;


  ngOnInit() {
    this.desabilitar = true;
    this.desabilitarRemover = true;
    this.desabilitarSalvar = true;
 
  }

  /*
   * Exibir a tela de detalhes da liquidação selecionada.
  */
exibirDetalhes(conteudo: any, item: any) {
  this.itemSelecionado = item;
    const options: IAslibModalOptions = {
    title: 'Detalhes da Carga de Dados',
    backdrop: 'static',
    footerVisible: true,
    size: 'lg',
    content: conteudo
  };
  this.aslibModal.open(options).result.then(
    () => { },
    () => { }
  );
}


async localizar(event: any, grid: AslibGridComponent) {
    this.file = null;
    this.nomeArquivo = '';
    const fileList = event.target.files;

    if (fileList.length > 0) {
      this.file = fileList[0];
      this.nomeArquivo = this.file.name.split('.x')[0];
      
      if(this.nomeArquivo.length>100){
        this.showModalAlert(
          'warning', 
          'Nome do Arquivo excede ao limite de 100 caracteres.', 
          'Favor diminuir o nome do arquivo.'
        );
        return;
      }

      if ((this.file.name.toLowerCase().includes('.xls')) || (this.file.name.toLocaleLowerCase().includes('.xlsx'))) {
        this.importarArquivo(this.file);
      } else {
        this.lista = [];
        this.preencherGrid(grid);     
 
        this.showModalAlert(
          'warning', 
          'Tipo de arquivo inválido.', 
          'Favor informar uma planilha Excel (.xls ou .xlsx)'
        );
      }
    }
  }

  remover(grid: AslibGridComponent){

    this.lista = this.lista.filter(item => item.statusValidacao !== 1);

    if (this.lista.length ==0) {

      this.exibirAviso('Os registros inválidos da GRID, foram removidos com sucesso. Porém não existe nenhum registro disponivel para ser salvo. Favor verificar.');

    } else{

      const dados = this.lista.find((d: { statusValidacao: number; }) => d.statusValidacao === 1);

      if (dados == null) {
        this.exibirSucesso('Os registros inválidos da GRID, foram removidos com sucesso.');
      } else {
        this.exibirAviso('Alguns dados da planilha não foram validados. Favor verificar.');
      }       
    }

    this.habilitaDesabilitaLimpar();
  }

  salvar(grid: AslibGridComponent) {
    this._service.routePrefix = '/api/CargaDados/Salvar';

    this.aslibLoadingService.start();
      this.subSave = this._service.add(this.lista, 'gpa' ).subscribe(data => {
        grid.dataset = data;
        this.lista = data;

      if (this.lista !=null && this.lista.length >0){
        // Verifica se algum registro não foi validado pra exibir a mensagem correta.
        const dados = data.find((d: { statusValidacao: number; }) => d.statusValidacao === 1);

        if (dados == null) {
          this.exibirSucesso('Os dados da planilha foram salvos com sucesso.'); 
          this.desabilitarSalvar = true;  
        } else {
          this.exibirAviso('Alguns dados da planilha não foram validados. Favor verificar.');
          this.desabilitarRemover = false;
        } 
      }

      },
      (error) => {
        this.exibirErro(error);
      },
      () => {
        this.aslibLoadingService.complete();
      }
    );
  }

  importarArquivo(file: File) {   
    const formData: FormData = new FormData();
    formData.append('file', this.file, this.file.name);
 
    this._service.routePrefix = '/api/CargaDados/Importar';
    this.aslibLoadingService.start();
   
    this.subListar = this._service.importarArquivo(formData, 'gpa').subscribe(data => {    
       
      if (typeof data === 'string') {      
          this.showModalAlert('warning', 'Importação da planilha', data);
          this.desabilitar = true;
          this.lista = null;
      } else {

          this.lista = data;
          this.lista.forEach((item) => item.nomeArquivo = this.file.name.split('.x')[0]);
      }

      this.habilitaDesabilitaLimpar();
      this.habilitaDesabilitaSalvar();

      },
      (error) => {
          this.exibirErro(error);
          this.aslibLoadingService.complete();
      },
      () => {
          this.aslibLoadingService.complete();          
      }
    );
  }

  preencherGrid(grid: AslibGridComponent): void {
    grid.dataset = this.lista;
  }
  
  detalharHistorico(item: any) {
    this.showCustomModal(item.historicoPagamento, 'Histórico do pagamento');
  }

  detalharPagamento(item: any) {
    var msg = "<b>Conta:"+item.historicoPagamento+"</b><br/>";
    this.showCustomModal(msg, 'Detalhe do pagamento');
  }

  exibirValidacao(item: any) {
    this.showCustomModal(item.mensagemValidacao, 'Validação');
  }

  habilitaDesabilitaLimpar(){
    const itens = this.lista;

    if(this.lista != null && this.lista.length >0){
      let dados = itens.find((d: { statusValidacao: number; }) => d.statusValidacao === this.statusNaoValidos)

      if (dados != null){
        this.desabilitarRemover = false;
       } else {
         this.desabilitarRemover = true;
      }
    }else{
      this.desabilitarRemover = true;
    }

    this.habilitaDesabilitaSalvar();
  }

  habilitaDesabilitaSalvar(){
    const itens = this.lista;

    if(this.lista != null && this.lista.length >0){
      let dados = itens.find((d: { statusValidacao: number; }) => d.statusValidacao === this.statusNaoValidos)

      if (dados != null){
        this.desabilitarSalvar = true;
      } else {
         this.desabilitarSalvar = false;
      }
    } else {
      this.desabilitarSalvar = true;  
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/pagamento/carga-dados/carga-dados.component.ts